import { render, staticRenderFns } from "./ExpenseFormModal.vue?vue&type=template&id=820c3098&scoped=true&"
import script from "./ExpenseFormModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseFormModal.vue?vue&type=style&index=0&id=820c3098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820c3098",
  null
  
)

export default component.exports